"use client";

import React from "react";
import { MapPin, Phone, Mail, ExternalLink } from "lucide-react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Separator } from "@/components/ui/separator";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-5 w-32 bg-background/10 animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        {[{
        label: "Home",
        href: "/HomePage"
      }, {
        label: "The Flight Plan",
        href: "/TheFlightPlanPage"
      }, {
        label: "Pilot Transitions",
        href: "/PilotTransitionsPage"
      }, {
        label: "The Crew",
        href: "/TheCrewPage"
      }].map((item, i) => <li key={i} data-index={i}>
            <Link to={item.href} className="text-background/80 hover:text-primary transition-colors duration-200 text-sm font-sans">
              {item.label}
            </Link>
          </li>)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-background/80 hover:text-primary transition-colors duration-200 text-sm font-sans">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <section data-section-id="265078" id="footer" className="bg-background border-t border-secondary">
      <div className="bg-foreground text-background pt-16 pb-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-12">
            {}
            <div className="flex flex-col gap-6">
              <Link to="/" className="inline-block w-fit">
                <WvcLogo className="h-8 w-auto text-background" />
              </Link>
              <p className="text-background/80 text-sm font-sans leading-relaxed max-w-xs">
                Lifetime in-home care planning for aging pilots. We design the flight plan that keeps you in your home and close to the hangar.
              </p>
            </div>

            {}
            <div className="flex flex-col gap-6">
              <h3 className="text-lg font-default font-bold tracking-tight text-background uppercase">
                Navigation
              </h3>
              <MenuProvider menu_id="50">
                <FooterMenuConsumer />
              </MenuProvider>
            </div>

            {}
            <div className="flex flex-col gap-6">
              <h3 className="text-lg font-default font-bold tracking-tight text-background uppercase">
                Technical Specs
              </h3>
              <div className="flex flex-col gap-4">
                <div className="flex items-start gap-3 text-background/80">
                  <MapPin className="w-5 h-5 shrink-0 mt-0.5 text-primary" />
                  <span className="text-sm font-sans leading-relaxed">
                    Southeast Regional HQ<br />
                    Aviation Way, Airpark 1<br />
                    United States
                  </span>
                </div>
                <Link to="/FAQPage" className="inline-flex items-center gap-2 text-sm font-sans font-medium text-background hover:text-primary transition-colors w-fit">
                  Review FAQ
                  <ExternalLink className="w-4 h-4" />
                </Link>
              </div>
            </div>

            {}
            <div className="flex flex-col gap-6">
              <h3 className="text-lg font-default font-bold tracking-tight text-background uppercase">
                Comms
              </h3>
              <div className="flex flex-col gap-4">
                <Link to="tel:8883702846" className="flex items-center gap-3 text-background/80 hover:text-primary transition-colors group w-fit">
                  <Phone className="w-5 h-5 shrink-0 group-hover:scale-110 transition-transform text-primary" />
                  <span className="text-sm font-mono font-medium">888-370-2846</span>
                </Link>
                <Link to="/FlightDeckPage" className="flex items-center gap-3 text-background/80 hover:text-primary transition-colors group w-fit">
                  <Mail className="w-5 h-5 shrink-0 group-hover:scale-110 transition-transform text-primary" />
                  <span className="text-sm font-sans">Contact Dispatch</span>
                </Link>
              </div>
            </div>
          </div>

          {}
          <div className="pt-8 border-t border-secondary/30 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-background/60 text-sm font-sans text-center md:text-left">
              © {currentYear} FINAL APPROACH CARE. ALL SYSTEMS GO.
            </p>
            <div className="flex items-center gap-6">
              <Link to="#" className="text-background/60 hover:text-primary text-sm font-sans transition-colors">
                Terms of Service
              </Link>
              <Link to="#" className="text-background/60 hover:text-primary text-sm font-sans transition-colors">
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}